import { urls } from "../../urls";
import type { NavItem } from "./navConfig";

/**
 * Whether a sidebar item should render as active for the current location.
 *
 * - Query items (status filters) require both the path and the exact query to match.
 * - Plain items match the path only when there is no query filter applied.
 * - A parent ("All …") item stays active on its detail sub-routes (`/path/:id`),
 *   but the home root never matches sub-routes.
 */
export const isNavItemActive = (item: NavItem, pathname: string, search: string): boolean => {
  if (item.query) {
    return pathname === item.path && search === `?${item.query}`;
  }
  if (pathname === item.path) {
    return search === "";
  }
  return item.path !== urls.app.home && pathname.startsWith(`${item.path}/`);
};
